import axios from "axios";
import {
    IServiceResult,
    ITerritoryType,
    ITerritoryTypePermission,
} from "../../Models/Models";
import { ITerritoryManagementAxios } from "../ITerritoryManagementAxios";

export class TerritoryManagementAxios implements ITerritoryManagementAxios {
    public GetTerritoryTypePermissions(
        territoryTypeId: number
    ): Promise<IServiceResult<Array<ITerritoryTypePermission>>> {
        const promise = new Promise<
      IServiceResult<Array<ITerritoryTypePermission>>
    >((resolve, reject) => {
        axios
            .get<IServiceResult<Array<ITerritoryTypePermission>>>(`/Territories/TerritoryTypePermissions?territoryTypeId=${territoryTypeId}`)
            .then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
    });

        return promise;
    }

    public UpdateTerritoryTypeAdminOnlyProperty(
        territoryType: ITerritoryType
    ): Promise<IServiceResult<number>> {
        const promise = new Promise<IServiceResult<number>>((resolve, reject) => {
            axios
                .post<IServiceResult<number>>("/Territories/TerritoryTypePrivileged", territoryType)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });

        return promise;
    }

    public UpdateTerritoryTypeUserPermissions(
        userID: number,
        territoryTypeID: number,
        canView: boolean,
        canEdit: boolean
    ): Promise<IServiceResult<null>> {
        const promise = new Promise<IServiceResult<null>>((resolve, reject) => {
            axios
                .post<IServiceResult<null>>(
                    "/Territories/UpdateTerritoryTypePermissions",
                    {
                        userID: userID,
                        territoryTypeID: territoryTypeID,
                        canView: canView,
                        canEdit: canEdit,
                    }
                )
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });

        return promise;
    }

    public UpdateTerritoryTypeUserPermissionsForAll(
        territoryPermissions: Array<ITerritoryTypePermission>
    ): Promise<IServiceResult<Array<ITerritoryTypePermission>>> {
        const promise = new Promise<IServiceResult<null>>((resolve, reject) => {
            axios
                .post<IServiceResult<null>>(
                    "/Territories/UpdateTerritoryTypePermissionsAllUsers",
                    {
                        territoryPermissions: territoryPermissions,
                    }
                )
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });

        return promise;
    }
}
